<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="gotoOverview()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>3</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 3 - Koppelen</v-list-tile-title>
						<v-list-tile-sub-title>Koppel je E-finder aan je telefoon</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

			<v-container class="item-group" mb-4>
				<h2>Gefeliciteerd</h2>
				<h3>Je E-finder is nu gekoppeld</h3><br/>
				<p>Nu nog een stap, het instellen van je WiFi. Als er nieuwe upgrades zijn voor de E-finder software wordt dit automatisch gedaan als je je E-finder oplaadt.</p>

				<v-btn block dark depressed large color="primary" @click="goNext()" class="mt-4">
					WiFi zoeken
				</v-btn>

			</v-container>
		</v-content>
	</div>
</template>

<script>
  import { mapMutations } from 'vuex';

  export default {
    computed: {
      device() {
        return this.$store.getters.device;
      },
    },
    data() {
      return {
      };
    },
    methods: {
      showMenu() {
        this.$store.dispatch('toggleMainMenu');
      },
      ...mapMutations(['showActivatedDialog']),
      gotoOverview() {
        this.$router.push({name: 'devices.list'});
      },
      goNext() {
        this.$router.push({name: 'devices.activate.wifi', params: { id: this.$route.params.id }});
	  }
    },
	created(){
      this.showActivatedDialog();
	}
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd
</style>
